import { render, staticRenderFns } from "./PwChangeForm.vue?vue&type=template&id=24387df8&"
import script from "./PwChangeForm.vue?vue&type=script&lang=ts&"
export * from "./PwChangeForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports